import React, { useState } from "react";
import { Section } from "./Section";

const FAQS = [
  {
    id: "faq-industries",
    q: "Which industries do you serve?",
    a: "We work with finance, healthcare, retail, manufacturing, education and travel/logistics teams — typically organisations between 50 and 5,000 employees with serious uptime requirements.",
  },
  {
    id: "faq-response",
    q: "What is your response time for incidents?",
    a: "Our SLA guarantees a 15-minute response for critical incidents, 24/7/365. Most P1 tickets are acknowledged in under five minutes.",
  },
  {
    id: "faq-migration",
    q: "How do you handle cloud migration?",
    a: "We start with a discovery and dependency map, then move workloads in low-risk waves with rollback plans, parallel running and zero-downtime cutovers.",
  },
  {
    id: "faq-uptime",
    q: "Do you guarantee uptime?",
    a: "Yes — managed environments are covered by a 99.99% uptime SLA, backed by financial credits if we miss it.",
  },
  {
    id: "faq-hybrid",
    q: "Can you manage hybrid cloud environments?",
    a: "Absolutely. We routinely operate hybrid estates spanning AWS, Azure, GCP and on-premise data centres under a single control plane.",
  },
  {
    id: "faq-includes",
    q: "What’s included in managed services?",
    a: "Monitoring, patching, backups, incident response, monthly reporting and a named engineer who knows your environment. No surprise add-ons.",
  },
];

export const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  return (
    <Section id="faq" className="bg-zinc-950 py-24 lg:py-32 border-t border-white/5">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          FAQ
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Common Questions About Our Services
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 xl:grid-cols-2 gap-4 xl:gap-6">
        {FAQS.map((item) => {
          const isOpen = openId === item.id;
          return (
            <div
              key={item.id}
              className="bg-white/[0.02] border border-white/10 rounded-2xl overflow-hidden"
            >
              <button
                type="button"
                data-testid={`${item.id}-toggle`}
                onClick={() => setOpenId(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-6 px-6 md:px-8 py-6 text-left hover:bg-white/[0.03] transition-colors duration-200"
              >
                <span
                  className="text-base md:text-lg font-semibold text-white"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {item.q}
                </span>
                <span
                  aria-hidden="true"
                  className={`flex-shrink-0 text-2xl text-[#FF4500] leading-none transition-transform duration-300 ${
                    isOpen ? "rotate-45" : "rotate-0"
                  }`}
                >
                  +
                </span>
              </button>
              <div
                data-testid={`${item.id}-panel`}
                className={`grid transition-all duration-300 ease-out ${
                  isOpen
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <div className="px-6 md:px-8 pb-6 text-sm md:text-base text-zinc-400 leading-relaxed">
                    {item.a}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default FAQ;
